import { render, staticRenderFns } from "./inline.vue?vue&type=template&id=5b2d41b6"
import script from "./inline.vue?vue&type=script&lang=js"
export * from "./inline.vue?vue&type=script&lang=js"
import style0 from "./inline.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports